import React from 'react';
import { truncateText, formatDateToMonthYear } from '../../../../../utils/sharedFunctions';
import { OutlinedButton } from '../../../../../components';

const backArrow = `${process.env.REACT_APP_CDN_URL}/globalAssets/leftarrow_back.svg`;
const EditIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/EditIcon.svg`;

const BriefHeader = ({ SelectedBrief, IsInfoEdit, handleBackClick, handleEditClicked, handleCancelEditClicked, handleSaveChangesClicked }) => {
    return (
        <div className='BriefTitle'>
            <div className='NameSection'>
                <img src={backArrow} alt='' style={{ width: '4%', cursor: 'pointer' }} onClick={handleBackClick} />
                <p>
                    {truncateText(SelectedBrief.briefTitle || SelectedBrief.title, 28)}
                    <span> - {formatDateToMonthYear(SelectedBrief.createdAt)}</span>
                </p>
            </div>
            {IsInfoEdit ? (
                <div className='BriefActionSection' style={{ width: '30%' }}>
                    <OutlinedButton style={{ width: '45%' }} onClick={handleCancelEditClicked}>Cancel</OutlinedButton>
                    <OutlinedButton style={{ width: '45%' }} onClick={handleSaveChangesClicked}>Save</OutlinedButton>
                </div>
            ) : (
                <div className='BriefActionSection' style={{ width: '5%' }}>
                    <img src={EditIcon} alt='Edit Icon.' style={{ cursor: 'pointer' }} onClick={handleEditClicked} />
                </div>
            )}
        </div>
    );
};

export default BriefHeader;